import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_axkt8rwjzs: FaireCollectionEntity = {
  token: "pbc_axkt8rwjzs",
  type: "collection",
  name: "gift wrap",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2f2e13ea4b3e8a21ca5bb73467a6fd94a5cd4e8969a08f20caf98920826f3884.jpeg",
  itemCount: 5,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:22.456Z",
    importedBy: "entity-db-import-collections",
  },
};
